export const topic = {
  breadCrumb: {
    libraryLink: "Conceive Library",
  },
  featuredArticle: {
    readMore: "Read More",
  },
};
